import React, { useEffect, useState, useRef } from 'react';
import ErrorScreen from './common/ErrorScreen';
import { DisplayWidget } from './components/DisplayWidget';
import { GuidPage } from './pages/GuidPage';

function App({ data }) {
  const [htmlContent, setHtmlContent] = useState('');
  const containerRef = useRef(null);
  const urlParams = new URLSearchParams(window.location.search);
  const guid = urlParams.get('guid');
  const token = urlParams.get('token');
  const bguid = urlParams.get('bguid');
  const siteUrl = urlParams.get('website');

  const defaultData = {
    guid: guid || data.guid,
    pcat: data?.pcat,
    pid: data?.pid,
    bguid: bguid || data?.bguid,
    version: data?.version,
    fromRedis: data?.fromRedis,
    fromApp: data?.fromApp,
    autoTrigger: data?.autoTrigger,
    reTarget: data?.reTarget,
  };

  function isParentDisplayNone(element) {
    while (element) {
      const style = window.getComputedStyle(element);
      if (style.display === 'none' || style.visibility === 'hidden') {
        return true;
      }
      element = element.parentElement;
    }
    return false;
  }

  function isAlreadyPresent() {
    let isAvailable = false;
    const parentElement = document.querySelector(`[data-guid="${defaultData?.guid}"]`);
    if (parentElement) {
      const children = parentElement.querySelectorAll('.Idukki-App');
      if (children.length == 1 || children.length > 1) {
        isAvailable = true;
      }
    }
    return isAvailable;
  }

  async function fetchAndInjectHTML() {
    try {
      const response = await fetch(`https://app.idukki.io/api/fetch-website?url=${siteUrl}`);
      const html = await response.json();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html.data, 'text/html');
      const sanitizedHTML = doc.documentElement.innerHTML;
      setHtmlContent(sanitizedHTML);
    } catch (error) {
      console.error('Failed to fetch HTML:', error);
    }
  }

  useEffect(() => {
    if (siteUrl) {
      fetchAndInjectHTML();
    }
  }, [siteUrl]);

  useEffect(() => {
    if (containerRef.current && htmlContent) {
      const footer = containerRef.current.querySelector('footer');
      if (footer) {
        const wrapper = document.createElement('div');
        wrapper.className = 'Idukki-App';
        footer.parentNode.insertBefore(wrapper, footer);

        import('react-dom/client').then(({ createRoot }) => {
          const root = createRoot(wrapper);
          root.render(<DisplayWidget props={defaultData} />);
        });
      }
    }
  }, [htmlContent]);

  const element = document.querySelector(`[data-ugc='idukki']`);

  const isGuidValid = (guid) => {
    if (guid == '' || !guid || (guid?.slice(0, 2) == '{{' && guid.slice(-2, guid?.length) == '}}')) return false;
    return true;
  };

  if (isGuidValid(defaultData?.guid)) {
    if (isParentDisplayNone(element) == false) {
      if (isAlreadyPresent() == false) {
        if (siteUrl) {
          return <idk-div ref={containerRef} dangerouslySetInnerHTML={{ __html: htmlContent }} />;
        } else {
          return (
            <idk-div class="Idukki-App">
              <DisplayWidget props={defaultData} />
            </idk-div>
          );
        }
      }
    }
  }

  if (token) {
    return (
      <idk-div class="Idukki-App">
        <GuidPage bguid={defaultData?.bguid} token={token} />
      </idk-div>
    );
  }

  return <ErrorScreen error="Error: Token is invalid" />;
}

export default App;
